import axios from 'axios';
import { params } from '../commons';
import store from '../redux/store';

const getAccessToken = () => store.getState().handleAuthorization.accessToken;
const getIdToken = () => store.getState().handleAuthorization.idToken;

export const fetchPlan = id =>
  axios({
    method: 'get',
    url: params.getPlanImageUrl(id),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'X-Forwarded-ID-Token': getIdToken(),
    },
  });

export const fetchPlanList = () =>
  axios({
    method: 'get',
    url: params.getPlansUrl(),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'X-Forwarded-ID-Token': getIdToken(),
    },
  });

export const fetchReservations = forDate =>
  axios({
    method: 'get',
    url: params.getReservationsUrl(forDate),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'X-Forwarded-ID-Token': getIdToken(),
    },
  });

export const fetchReservationById = id =>
  axios({
    method: 'get',
    url: params.getReservationByIdUrl(id),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'X-Forwarded-ID-Token': getIdToken(),
    },
  });

export const searchReservations = filters =>
  axios({
    method: 'post',
    url: params.searchReservationsUrl(),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Forwarded-ID-Token': getIdToken(),
    },
    data: filters,
  });

export const deleteReservation = reservationId =>
  axios({
    method: 'delete',
    url: params.deleteReservationUrl(reservationId),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Forwarded-ID-Token': getIdToken(),
    },
  });

export const deleteReservationSeries = reservationSeriesId =>
  axios({
    method: 'delete',
    url: params.deleteReservationSeriesUrl(reservationSeriesId),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Forwarded-ID-Token': getIdToken(),
    },
  });

export const createReservation = reservation =>
  axios({
    method: 'post',
    url: params.postReservationUrl(),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Forwarded-ID-Token': getIdToken(),
    },
    data: reservation,
  });

export const postReservationSeriesFavorite = reservation =>
  axios({
    method: 'post',
    url: params.postReservationSeriesFavorite(),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Forwarded-ID-Token': getIdToken(),
    },
    data: reservation,
  });

export const postReservationSeries = reservation =>
  axios({
    method: 'post',
    url: params.postReservationSeries(),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Forwarded-ID-Token': getIdToken(),
    },
    data: reservation,
  });

export const fetchSpaces = forDate =>
  axios({
    method: 'get',
    url: params.getSpacesUrl(forDate),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'X-Forwarded-ID-Token': getIdToken(),
    },
  });

export const updateReservation = (reservation, id) =>
  axios({
    method: 'put',
    url: params.putReservationUrl(id),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Forwarded-ID-Token': getIdToken(),
    },
    data: reservation,
  });

export const fetchUserProfileByLogin = login =>
  axios({
    method: 'get',
    url: params.getUserInfoByLoginUrl(login),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });

export const fetchFilteredUsers = employeeIds =>
  axios({
    method: 'get',
    url: params.fetchFilteredUsers(employeeIds),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
    },
  });

export const fetchAKRAUsers = () =>
  axios({
    method: 'get',
    url: params.fetchAKRAUsers(),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
      ConsistencyLevel: 'eventual',
    },
  });

export const fetchSpacesUsers = () =>
  axios({
    method: 'get',
    url: params.fetchSpacesUsers(),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
      ConsistencyLevel: 'eventual',
    },
  });

export const createFavorites = favorites =>
  axios({
    method: 'post',
    url: params.createFavorites(),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Forwarded-ID-Token': getIdToken(),
    },
    data: favorites,
  });

export const fetchFavoritesByLogin = login =>
  axios({
    method: 'get',
    url: params.fetchFavoritesByLogin(login),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Forwarded-ID-Token': getIdToken(),
    },
  });

export const deleteFavorites = favoriteId =>
  axios({
    method: 'delete',
    url: params.deleteFavorites(favoriteId),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Forwarded-ID-Token': getIdToken(),
    },
  });

export const updateFavorites = (favoriteId, data) =>
  axios({
    method: 'put',
    url: params.updateFavorites(favoriteId),
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      'Content-Type': 'application/json; charset=UTF-8',
      'X-Forwarded-ID-Token': getIdToken(),
    },
    data,
  });

export const fetchBackendVersion = () =>
  axios({
    method: 'get',
    url: params.getVersion(),
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
  });
